import { AuthContext, SettingsContext } from "context";
import { useContext, useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { PageType } from "types";
import { IFrame, Image, Layout, RequireAuth, RotateBanner } from "./components";
import {
  CallCenterEditable,
  ChatBot,
  DynamicRoutes,
  FlorenceModel,
  Home,
  Login,
  Logout,
  ProductRecommendation,
  ShoppingAssistantCosmos,
  ShoppingCopilot,
  ShoppingCopilotCosmos,
  ShoppingCopilotHC,
  ShoppingCopilotMTC,
  SocialMediaCampaign,
} from "./pages";
import "./app.scss";
import {
  CONTOSO_COPILOT_DEMOS,
  getIFrameUrl,
  CONTOSO_COPILOT_PROD,
  CONTOSO_COPILOT_WITH_WEBSOCKET,
  toolTips,
} from "common";
import { ShoppingCopilotUAT } from "pages/ShoppingCopilotUAT";
import {
  MsalAuthenticationTemplate,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import axios from "axios";

function App() {
  const { currentDemo } = useContext(SettingsContext);
  const { trackDemoLoad, trackNavigation } = useContext(AuthContext);
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const [EmailDomains, setEmailDomains] = useState([]);
  const { accounts, instance, inProgress } = useMsal();

  useEffect(() => {
    trackDemoLoad();
  }, [isAuthenticated]);

  useEffect(() => {
    const item = toolTips?.filter(
      (item) =>
        `${item.url}` ===
        location.pathname.split("/")?.[2]?.replaceAll("-", "_")
    )?.[0];
    if (item?.value) {
      trackNavigation(item?.value);
    }
  }, [location, toolTips]);
  useEffect(() => {
    const fetchEmailDomains = async () => {
      try {
        const demoId = 1; // Replace with your actual demo id
        const response = await axios.get(
          `https://app-common-powerbi-server.azurewebsites.net/EmailDomains/GetDemoEmailDomains?DemoId=${demoId}`
        );
        setEmailDomains(response.data);
        if (accounts.length) {
          const user = accounts[0].username;
          const usernameDomain = user.split("@")[1];

          const isMS = (response.data as any)?.data?.some(
            (domain: { emailDomain: string }) => {
              return domain.emailDomain === `@${usernameDomain}`;
            }
          );

          if (!isMS) {
            alert("You don't have access to this");
            instance.logout();
          }
        }

        if (!isAuthenticated && !accounts.length && inProgress === "none") {
          instance.loginRedirect();
        }
      } catch (error) {
        console.error("Error fetching email domains:", error);
      }
    };
    fetchEmailDomains();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts, inProgress, isAuthenticated]);
  return (
    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
      <Routes>
        {/* <Route path="/settings" element={<Settings />} /> */}
        <Route path="logout" element={<Logout />} />
        <Route path="/" element={<Home />} />
        <Route path="/:id" element={<DynamicRoutes />}>
          <Route path="login" element={<Login />} />
          <Route
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            {/* {currentDemo?.iFrames?.map((frame: any, index: number) => {
              if (frame.link.includes("http")) {
                return (
                  <Route
                    key={frame.title + index}
                    path={frame.routeName.split("/")[1]}
                    element={
                      <IFrame
                        pageTitle={frame.title}
                        pageType={PageType.IFrame}
                        url={frame.link}
                        id={frame.title}
                      />
                    }
                  />
                );
              }
            })} */}
            <Route path="florence-model" element={<FlorenceModel />} />
            <Route
              path="florence-recommendation"
              element={<ProductRecommendation />}
            />
            <Route
              path="social-media-campaign"
              element={<SocialMediaCampaign />}
            />
            <Route path="chat-bot" element={<ChatBot />} />
            <Route
              path="chat-bot-2"
              element={CONTOSO_COPILOT_PROD ? <ChatBot /> : <></>}
            />
            <Route
              path="shopping-copilot"
              element={
                CONTOSO_COPILOT_DEMOS.includes(currentDemo?.guid) ? (
                  <ShoppingCopilot />
                ) : (
                  <></>
                )
              }
            />
            <Route
              path="shopping-copilot-uat"
              element={
                CONTOSO_COPILOT_DEMOS.includes(currentDemo?.guid) ? (
                  <ShoppingCopilotUAT />
                ) : (
                  <></>
                )
              }
            />

            <Route
              path="shopping-copilot-mtc"
              element={
                CONTOSO_COPILOT_PROD === currentDemo?.guid ? (
                  <ShoppingCopilotMTC />
                ) : (
                  <></>
                )
              }
            />

            <Route
              path="shopping-copilot-new"
              element={
                CONTOSO_COPILOT_DEMOS.includes(currentDemo?.guid) ? (
                  <ShoppingCopilotHC />
                ) : (
                  <></>
                )
              }
            />

            <Route
              path="shopping-copilot-cosmos"
              element={
                CONTOSO_COPILOT_PROD === currentDemo?.guid ? (
                  <ShoppingCopilotCosmos />
                ) : (
                  <></>
                )
              }
            />

            <Route
              path="shopping-assistant-cosmos"
              element={
                CONTOSO_COPILOT_WITH_WEBSOCKET === currentDemo?.guid ? (
                  <ShoppingAssistantCosmos />
                ) : (
                  <></>
                )
              }
            />

            <Route
              path="smart-factory"
              element={
                <IFrame
                  url="https://app-manufacturingdemo-prod.azurewebsites.net/#/factory-2"
                  pageTitle="Smart Factory with Azure AI"
                  pageType={PageType.SmartFactory}
                />
              }
            />

            <Route
              path="call-center"
              element={
                <CallCenterEditable
                  showBeforeScript={false}
                  showCallCenterBefore={false}
                  showAfterSummary={false}
                  showCallCenterAfter={false}
                  showCustomerConversation={false}
                />
              }
            />

            <Route
              path="call-center-after-summary"
              element={
                <CallCenterEditable
                  showBeforeScript={false}
                  showCallCenterBefore={false}
                  showAfterSummary={true}
                  showCallCenterAfter={true}
                  showCustomerConversation={false}
                />
              }
            />

            <Route
              path="call-center-after-script"
              element={
                <CallCenterEditable
                  showBeforeScript={false}
                  showCallCenterBefore={false}
                  showAfterSummary={false}
                  showCallCenterAfter={true}
                  showCustomerConversation={false}
                />
              }
            />

            <Route
              path="call-center-before-script"
              element={
                <CallCenterEditable
                  showBeforeScript={true}
                  showCallCenterBefore={true}
                  showAfterSummary={false}
                  showCallCenterAfter={false}
                  showCustomerConversation={false}
                />
              }
            />

            <Route
              path="call-center-before-summary"
              element={
                <CallCenterEditable
                  showBeforeScript={false}
                  showCallCenterBefore={true}
                  showAfterSummary={false}
                  showCallCenterAfter={false}
                  showCustomerConversation={false}
                />
              }
            />

            <Route
              path="customer-conversation"
              element={
                <CallCenterEditable
                  showBeforeScript={false}
                  showCallCenterAfter={false}
                  showCallCenterBefore={false}
                  showAfterSummary={false}
                  showCustomerConversation={true}
                />
              }
            />

            <Route
              path="landing-page"
              element={
                <Image
                  pageTitle="Landing Page"
                  pageType={PageType.LandingPage}
                  src={currentDemo?.landingPageImage}
                  blobUrl=""
                />
              }
            />

            <Route
              path="world-map"
              element={
                <IFrame
                  pageTitle="World Map"
                  pageType={PageType.WorldMap}
                  url={getIFrameUrl(currentDemo?.guid).worldMap}
                />
              }
            />

            <Route
              path="city-view"
              element={
                <IFrame
                  pageTitle="City View"
                  pageType={PageType.CityView}
                  url={getIFrameUrl(currentDemo?.guid).cityView}
                />
              }
            />

            <Route
              path="org-chart"
              element={
                <IFrame
                  pageTitle="ORG Chat"
                  pageType={PageType.ORGChart}
                  url={getIFrameUrl(currentDemo?.guid).orgChart}
                />
              }
            />

            <Route
              path="ceo-dashboard-before"
              element={
                <IFrame
                  pageTitle="CEO Dashboard - Before"
                  pageType={PageType.CEODashboardBefore}
                  url={getIFrameUrl(currentDemo?.guid).ceoDashboardBefore}
                />
              }
            />

            <Route
              path="ceo-dashboard-after"
              element={
                <IFrame
                  pageTitle="CEO Dashboard After"
                  pageType={PageType.CEODashboardAfter}
                  url={getIFrameUrl(currentDemo?.guid).ceoDashboardAfter}
                />
              }
            />

            <Route
              path="finale-video"
              element={
                <IFrame
                  pageTitle="Finale Video"
                  pageType={PageType.FinaleVideo}
                  url={getIFrameUrl(currentDemo?.guid).finaleVideo}
                />
              }
            />
          </Route>
        </Route>
        {currentDemo?.guid && (
          <Route
            path="*"
            element={<Navigate to={`/${currentDemo?.guid}/login`} />}
          />
        )}
      </Routes>
    </MsalAuthenticationTemplate>
  );
}

export default App;
